import { render, staticRenderFns } from "./channelRegistrationList.vue?vue&type=template&id=79fc1e8c&scoped=true"
import script from "./channelRegistrationList.vue?vue&type=script&lang=js"
export * from "./channelRegistrationList.vue?vue&type=script&lang=js"
import style0 from "./channelRegistrationList.vue?vue&type=style&index=0&id=79fc1e8c&prod&lang=less&scoped=true"
import style1 from "./channelRegistrationList.vue?vue&type=style&index=1&id=79fc1e8c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79fc1e8c",
  null
  
)

export default component.exports